// eslint-disable-next-line no-restricted-imports
import { CreateClientByAdminDto_Input } from 'api/generated/graphql';
import { CreateClientParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseCreateClientParam = (
  data: CreateClientParam
): CreateClientByAdminDto_Input => ({
  email: data.email,
  firstName: data.firstName,
  lastName: data.lastName,
  middleName: data.middleName,
  phoneNumber: data.phoneNumber,
  dateOfBirth: formatToISODate(data.dateOfBirth),
  personalAccount: {
    number: data.personalAccountNumber,
    openingDate: formatToISODate(data.personalAccountOpeningDate),
  },
  companySignedAgreementFileId_Finance:
    data.companySignedAgreementFileId_Finance,
  companySignedClientServiceAgreementFileId_Global:
    data.companySignedClientServiceAgreementFileId_Global,
  companySignedNoticeOfInvestmentAccountOpeningFileId:
    data.companySignedNoticeOfInvestmentAccountOpeningFileId,
  brightCode: data.brightCode,
  representative: data.representative
    ? {
        email: data.representative.email,
        firstName: data.representative.firstName,
        lastName: data.representative.lastName,
        middleName: data.representative.middleName,
        phoneNumber: data.representative.phoneNumber,
        dateOfBirth: formatToISODate(data.representative.dateOfBirth),
      }
    : undefined,
});
